<template>
  <v-draggable>
    <v-window ref="window" defaultClosed :class="$style.wrapper" width="84rem" title="Password">
      <div :class="$style.inner">
        <div :class="$style.top">
          <div>
            <div>Сайт</div>
            <div>Пароль</div>
            <div>Статус</div>
          </div>
        </div>
        <div :class="$style.body">
          <div v-for="(item, index) in data.sites" :key="item.title" :class="$style.site">
            <div>
              <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.2662 8.34397V5.03165C11.2662 3.69718 10.7656 2.41736 9.87441 1.47374C8.98325 0.530119 7.77458 0 6.51429 0C5.254 0 4.04532 0.530119 3.15417 1.47374C2.26301 2.41736 1.76236 3.69718 1.76236 5.03165V8.34397C1.29298 8.35025 0.84483 8.55206 0.514971 8.90571C0.185112 9.25935 9.79281e-05 9.73635 0 10.2334L2.4642e-05 17.9487C2.4642e-05 20.0743 13.0286 20.0743 13.0286 17.9487L13.0285 10.2334C13.0284 9.73636 12.8434 9.25936 12.5136 8.90572C12.1837 8.55208 11.7356 8.35026 11.2662 8.34397V8.34397ZM3.92984 8.34273V5.03165C3.92984 4.30587 4.20213 3.60981 4.68681 3.0966C5.17148 2.58339 5.82885 2.29507 6.51429 2.29507C7.19972 2.29507 7.85709 2.58339 8.34177 3.0966C8.82644 3.60981 9.09873 4.30587 9.09873 5.03165V8.34273H3.92984Z" fill="#09E56E"/>
              </svg>
              {{item.title}}
            </div>
            <div>
              {{item.password}}
            </div>
            <div>
              <v-btn large @click="() => save(index)" :color="item.saved ? 'green' : 'black'">
                <template v-if="item.saved">
                  <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 9.41176L8.79412 16.2059L23 2" stroke="white" stroke-width="3"/>
                  </svg>
                </template>
                <template v-else>
                  Сохранить
                </template>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </v-window>
  </v-draggable>
</template>
<script>
export default {
  name: 'passwords',
  props: {
    data: Object,
  },
  methods: {
    open() {
      this.$refs.window.open()
      this.data.tasks[8].current = true
      this.$emit('box', 'box3')
    },
    close() {
      this.$refs.window.close()
      this.data.tasks[8].current = false
    },
    save(index) {
      const site = this.data.sites[index]

      if (site.saved) return

      site.saved = true

      this.check()
    },
    check() {
      const { sites } = this.data
      if (sites.filter(item => item.saved).length === sites.length) {
        this.data.tasks[8].ready = true
        this.$store.commit('SET_RESULT', 5)
        this.$emit('success')
        this.close()
      }
    },
  },
}
</script>
<style lang="scss" module>
.wrapper {
  left: 33.2rem;
  top: 8.7rem;
  height: 46.5rem;
}

.inner {
  background: #F0F0F5;
  border-radius: 1.5rem;
  height: 37rem;
  margin: 1.5rem;
  padding: 3.2rem;
}

.top, .body {
  & > div {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > div {
      width: 33.33%;
      flex-shrink: 0;

      &:nth-child(3) {
        width: 23%;
      }
    }
  }
}

.top {
  font-size: 1.8rem;
  line-height: 1.2222;
  color: #C4C4C4;
  padding-bottom: 1rem;
  border-bottom: 1px solid #DADADA;
}

.body {
  font-size: 2.1rem;
  margin-top: 1.2rem;

  & > div {
    & + div {
      margin-top: 2.5rem;
    }
  }
}

.site {
  & > div:nth-child(1) {
    color: #09E56E;
    display: flex;
    align-items: center;

    svg {
      width: 1.3rem;
      margin-right: 0.5rem;
    }
  }

  & > div:nth-child(3) {
    svg {
      width: 2.5rem;
      height: auto;
    }
  }
}
</style>
